import React from 'react';
import PropTypes from 'prop-types';
import LocaleText from '../../LocaleText';

class Materials extends React.Component {
    renderMaterial(material) {
        const isActive = this.props.activeMaterial === material.name;
        const classes = ['menu__item'];

        if (isActive) {
            classes.push('menu__item--active');
        }

        return (
            <li
                className={classes.join(' ')}
                key={material.name}
                onClick={() => this.props.setActiveMaterial(material.name)}
            >
                <span className="label">
                    <LocaleText textKey={material.name} />
                </span>
            </li>
        );
    }

    render() {
        const { materials } = this.props;
        return (
            <div className="submenu__row material-selection">
                <ul className="menu">
                    {Object.keys(materials).map((key, i) => this.renderMaterial(materials[key], i))}
                </ul>
            </div>
        );
    }
}

Materials.propTypes = {
    materials: PropTypes.object.isRequired,
    activeMaterial: PropTypes.string.isRequired,
    setActiveMaterial: PropTypes.func.isRequired,
};

export default Materials;
